<div class="mini-grid">

  <div class="mini-grid_date" *ngIf="sku?.bbUpdated">
    <b>Last Updated:</b> {{ sku?.bbUpdated | date: "short" }}
  </div>
  <div class="mini-grid_grid-wrapper">
    <ag-grid-angular
      style="width: 100%; height: 300px"
      [ngClass]="{'mini-grid_height' : isSidePanel}"
      class="ag-theme-alpine-thin"
      [gridOptions]="gridOptions"     
      [rowHeight]="30"
      [headerHeight]="30" 
    >
    </ag-grid-angular>
  </div>
</div>
